// src/BiocharResources.js
import React, { useState } from 'react';
import { useLanguage } from './contexts/LanguageContext';

export default function BiocharResources() {
  const { language } = useLanguage();
  const [showImage, setShowImage] = useState(false);

  const getText = (en, sw) => {
    if (language === 'sw') return sw;
    return en;
  };

  // Document groups
  const kilnGuides = [
    {
      num: 1,
      title_en: 'Build & Site Selection',
      title_sw: 'Ujenzi na Uchaguzi wa Eneo',
      desc_en: 'Main build instructions, specifications, kiln placement, materials, and construction steps.',
      desc_sw: 'Maelekezo makuu ya ujenzi, vipimo, uwekaji wa tanuru, vifaa, na hatua za ujenzi.',
      file_en: 'Doc1_Build_Site_Selection_EN.docx',
      file_sw: 'Doc1_Ujenzi_Uchaguzi_Eneo_SW.docx'
    },
    {
      num: 2,
      title_en: 'Alternative Stone & Free-Material Build',
      title_sw: 'Ujenzi Mbadala wa Mawe na Vifaa vya Bure',
      desc_en: 'Safe use of local stones and bricks, zero-cost build methods, and safety rules.',
      desc_sw: 'Matumizi salama ya mawe ya ndani na matofali, njia za ujenzi bila gharama, na sheria za usalama.',
      file_en: 'Doc2_Alternative_Stone_Build_EN.docx',
      file_sw: 'Doc2_Ujenzi_Mawe_Mbadala_SW.docx'
    },
    {
      num: 3,
      title_en: 'First Burns, Biochar Making & Soil Use',
      title_sw: 'Uchomaji wa Kwanza, Utengenezaji wa Biochar na Matumizi ya Udongo',
      desc_en: 'Test firing, safe operation, biochar production, activation, and soil application.',
      desc_sw: 'Majaribio ya moto, uendeshaji salama, uzalishaji wa biochar, uanzishaji, na matumizi ya udongo.',
      file_en: 'Doc3_First_Burns_Biochar_EN.docx',
      file_sw: 'Doc3_Uchomaji_Kwanza_Biochar_SW.docx'
    }
  ];

  const additionalGuides = [
    {
      title_en: 'Semi-Permanent Weather Resilient Biochar Kiln',
      title_sw: 'Tanuru ya Biochar Inayostahimili Hali ya Hewa ya Nusu-Kudumu',
      desc_en: 'Durable design for areas with heavy rainfall or extreme weather conditions.',
      desc_sw: 'Muundo wa kudumu kwa maeneo yenye mvua kubwa au hali mbaya ya hewa.',
      file: 'Semi-Permanent Weather Resilient Biochar Kiln.docx'
    },
    {
      title_en: 'Permanent Inverted Cone Kiln',
      title_sw: 'Tanuru ya Kudumu ya Koni Iliyogeuzwa',
      desc_en: 'Long-term installation guide for permanent kiln structures.',
      desc_sw: 'Mwongozo wa usakinishaji wa muda mrefu kwa miundo ya tanuru ya kudumu.',
      file: 'Permanent Inverted Cone Kiln.docx'
    }
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      {/* Header */}
      <h2 style={{ color: '#4ade80', marginBottom: '10px' }}>
        {getText('Biochar Resources', 'Rasilimali za Biochar')}
      </h2>
      <p style={{ color: '#888', marginBottom: '30px' }}>
        {getText(
          'Guides and instructions for building and using biochar kilns',
          'Miongozo na maelekezo ya kujenga na kutumia tanuru za biochar'
        )}
      </p>

      {/* Main Kiln Guide Series */}
      <div style={{ 
        background: '#1a3327', 
        padding: '20px', 
        borderRadius: '12px', 
        marginBottom: '24px',
        border: '1px solid #2d5a45'
      }}>
        <h3 style={{ color: '#4ade80', marginTop: 0, marginBottom: '20px', fontSize: '18px' }}>
          {getText('Inverted Cone Earth Biochar Kiln Guide', 'Mwongozo wa Tanuru ya Biochar ya Koni Iliyogeuzwa')}
        </h3>

        {kilnGuides.map((doc) => (
          <div key={doc.num} style={{ 
            background: '#0f2419', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: '12px',
            border: '1px solid #2d5a45'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <div style={{ 
                background: '#4ade80', 
                color: '#0f2419', 
                width: '32px', 
                height: '32px', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontWeight: 'bold',
                flexShrink: 0
              }}>
                {doc.num}
              </div>
              <div style={{ flex: 1 }}>
                <h4 style={{ color: 'white', margin: '0 0 6px 0', fontSize: '16px' }}>
                  {getText(doc.title_en, doc.title_sw)}
                </h4>
                <p style={{ color: '#888', margin: '0 0 12px 0', fontSize: '14px' }}>
                  {getText(doc.desc_en, doc.desc_sw)}
                </p>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <a 
                    href={`/resources/biochar/${doc.file_en}`}
                    download
                    style={{ 
                      padding: '8px 16px', 
                      background: '#4ade80', 
                      color: '#0f2419', 
                      textDecoration: 'none', 
                      borderRadius: '6px', 
                      fontSize: '13px',
                      fontWeight: 'bold',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    English
                  </a>
                  <a 
                    href={`/resources/biochar/${doc.file_sw}`}
                    download
                    style={{ 
                      padding: '8px 16px', 
                      background: '#3b82f6', 
                      color: 'white', 
                      textDecoration: 'none', 
                      borderRadius: '6px', 
                      fontSize: '13px',
                      fontWeight: 'bold',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    Kiswahili
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Kiln Diagram */}
      <div style={{ 
        background: '#1a3327', 
        padding: '20px', 
        borderRadius: '12px', 
        marginBottom: '24px',
        border: '1px solid #2d5a45'
      }}>
        <h3 style={{ color: '#4ade80', marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>
          {getText('Kiln Diagram', 'Mchoro wa Tanuru')}
        </h3>
        <div 
          onClick={() => setShowImage(true)}
          style={{ 
            cursor: 'pointer',
            background: '#0f2419',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'center'
          }}
        >
          <img 
            src="/resources/biochar/kiln-diagram.png" 
            alt="Kiln Diagram"
            style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px' }}
          />
          <p style={{ color: '#888', fontSize: '13px', marginTop: '10px', marginBottom: 0 }}>
            {getText('Click to enlarge', 'Bofya kupanua')}
          </p>
        </div>
      </div>

      {/* Additional Guides */}
      <div style={{ 
        background: '#1a3327', 
        padding: '20px', 
        borderRadius: '12px', 
        marginBottom: '24px',
        border: '1px solid #2d5a45'
      }}>
        <h3 style={{ color: '#4ade80', marginTop: 0, marginBottom: '20px', fontSize: '18px' }}>
          {getText('Additional Biochar Guides', 'Miongozo ya Ziada ya Biochar')}
        </h3>

        {additionalGuides.map((doc, index) => (
          <div key={index} style={{ 
            background: '#0f2419', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: index < additionalGuides.length - 1 ? '12px' : 0,
            border: '1px solid #2d5a45'
          }}>
            <h4 style={{ color: 'white', margin: '0 0 6px 0', fontSize: '16px' }}>
              {getText(doc.title_en, doc.title_sw)}
            </h4>
            <p style={{ color: '#888', margin: '0 0 12px 0', fontSize: '14px' }}>
              {getText(doc.desc_en, doc.desc_sw)}
            </p>
            <a 
              href={`/resources/biochar/${doc.file}`}
              download
              style={{ 
                padding: '8px 16px', 
                background: '#4ade80', 
                color: '#0f2419', 
                textDecoration: 'none', 
                borderRadius: '6px', 
                fontSize: '13px',
                fontWeight: 'bold'
              }}
            >
              {getText('Download', 'Pakua')}
            </a>
          </div>
        ))}
      </div>

      {/* Biochar Information */}
      <div style={{ 
        background: '#1a3327', 
        padding: '20px', 
        borderRadius: '12px', 
        marginBottom: '24px',
        border: '1px solid #2d5a45'
      }}>
        <h3 style={{ color: '#4ade80', marginTop: 0, marginBottom: '20px', fontSize: '18px' }}>
          {getText('Biochar Information', 'Taarifa za Biochar')}
        </h3>

        {[
          {
            title_en: 'Approved Biomass & Biochar Activation',
            title_sw: 'Biomasi Iliyoidhinishwa na Uanzishaji wa Biochar',
            desc_en: 'Which materials can be used to make biochar and how to activate it before applying to soil.',
            desc_sw: 'Vifaa gani vinaweza kutumika kutengeneza biochar na jinsi ya kuianzisha kabla ya kuiweka kwenye udongo.',
            file: 'Approved_Biomass_and_Biochar_Activation.docx'
          },
          {
            title_en: 'Biochar Fact Sheet & FAQs',
            title_sw: 'Karatasi ya Ukweli wa Biochar na Maswali',
            desc_en: 'Common questions about biochar, soil health, carbon credits, and farmer income.',
            desc_sw: 'Maswali ya kawaida kuhusu biochar, afya ya udongo, mikopo ya kaboni, na mapato ya wakulima.',
            file: 'Biochar_Fact_Sheet.docx'
          },
          {
            title_en: 'Biochar to Soil — Carbon Credit Overview',
            title_sw: 'Biochar hadi Udongo — Muhtasari wa Mikopo ya Kaboni',
            desc_en: 'How the initiative works, what farmers earn, payment structure, and how to join.',
            desc_sw: 'Jinsi mpango unavyofanya kazi, wakulima wanapata nini, muundo wa malipo, na jinsi ya kujiunga.',
            file: 'Biochar_to_Soil_Carbon_Credit_Overview.docx'
          }
        ].map((doc, index, arr) => (
          <div key={index} style={{ 
            background: '#0f2419', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: index < arr.length - 1 ? '12px' : 0,
            border: '1px solid #2d5a45'
          }}>
            <h4 style={{ color: 'white', margin: '0 0 6px 0', fontSize: '16px' }}>
              {getText(doc.title_en, doc.title_sw)}
            </h4>
            <p style={{ color: '#888', margin: '0 0 12px 0', fontSize: '14px' }}>
              {getText(doc.desc_en, doc.desc_sw)}
            </p>
            <a 
              href={`/resources/biochar/${doc.file}`}
              download
              style={{ 
                padding: '8px 16px', 
                background: '#4ade80', 
                color: '#0f2419', 
                textDecoration: 'none', 
                borderRadius: '6px', 
                fontSize: '13px',
                fontWeight: 'bold'
              }}
            >
              {getText('Download', 'Pakua')}
            </a>
          </div>
        ))}
      </div>

      {/* Safety Notice */}
      <div style={{ 
        background: '#fef3c7', 
        padding: '16px', 
        borderRadius: '8px',
        border: '1px solid #f59e0b'
      }}>
        <h4 style={{ color: '#92400e', margin: '0 0 8px 0', fontSize: '15px' }}>
          {getText('Safety Notice', 'Taarifa ya Usalama')}
        </h4>
        <p style={{ color: '#92400e', margin: 0, fontSize: '14px' }}>
          {getText(
            'Always follow safety guidelines when building and operating kilns. Keep children away from active kilns. Never leave a burning kiln unattended.',
            'Fuata miongozo ya usalama kila wakati unapojenga na kuendesha tanuru. Weka watoto mbali na tanuru zinazofanya kazi. Kamwe usiache tanuru inayowaka bila uangalizi.'
          )}
        </p>
      </div>

      {/* Image Modal */}
      {showImage && (
        <div 
          onClick={() => setShowImage(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            cursor: 'pointer'
          }}
        >
          <img 
            src="/resources/biochar/kiln-diagram.png" 
            alt="Kiln Diagram"
            style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: '8px' }}
          />
        </div>
      )}
    </div>
  );
}